const active = new Map();
// Existing drafts predate the pre-review resolver. Prepare their saved payload
// once, without re-uploading the workbook, before exposing the editable grid.
export async function ensureYahooReviewPrepared(data, { api, getApiUrl, campaignId, accountId, userId, wait = (ms) => new Promise((r) => setTimeout(r, ms)) }) {
  if (data?.alreadyLaunched || data?.launched || !data?.launcherResult?.customData?.unresolved
      || !['yahoo', 'yahoo-dsp', 'yahoo_dsp', 'yahoodsp'].includes(String(data.launcherResult.platform || '').toLowerCase())) return data;
  const key = `${accountId}:${campaignId}`;
  if (!active.has(key)) {
    const job = (async () => {
      const path = `/api/v2/campaigns/${campaignId}/yahoo-targeting/prepare`;
      let result = (await api.post(getApiUrl(path), { accountId, userId })).data;
      const runId = result.runId;
      if (result.status !== 'done' && !runId) throw new Error('Yahoo targeting preparation did not return a run ID.');
      for (let count = 0; result.status !== 'done' && count < 600; count++) {
        await wait(1500);
        const status = (await api.get(getApiUrl(`${path}/${runId}`), { params: { accountId, userId } })).data;
        if (status.status === 'error') throw new Error(status.error || 'Yahoo targeting preparation failed.');
        if (status.status === 'ready') result = (await api.post(getApiUrl(path), { accountId, userId, runId })).data;
      }
      if (result.status !== 'done') throw new Error('Yahoo targeting preparation timed out. Reload to retry.');
      return result;
    })();
    active.set(key, job);
  }
  try {
    const result = await active.get(key);
    return { ...data, launcherResult: result.launcherResult, launcherResultPath: result.editedLauncherResultPath };
  } catch (e) {
    const error = new Error(e?.response?.data?.error || e.message || 'Yahoo targeting preparation failed.');
    error.yahooPreparation = true;
    throw error;
  } finally { active.delete(key); }
}
